import { render, staticRenderFns } from "./PrependComponent.vue?vue&type=template&id=0fc9eecd&lang=pug&"
import script from "./PrependComponent.vue?vue&type=script&lang=js&"
export * from "./PrependComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports